import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {PaymentOptionType} from '@wix/auto_sdk_ecom_current-cart';

export const PaymentTypeLabel = ({lineItem}: {lineItem: LineItemModel}) => {
  const {paymentConfig, pricing} = lineItem;
  const {t} = useTranslation();

  const getLabel = () => {
    switch (lineItem.paymentConfig.paymentOption) {
      case PaymentOptionType.DEPOSIT_ONLINE:
        return paymentConfig.depositAmount.convertedAmount > 0
          ? t('cart.myCartPaymentMethod.deposit.lineItem', {
              price: paymentConfig.depositAmount.formattedConvertedAmount,
            })
          : '';
      case PaymentOptionType.MEMBERSHIP:
      case PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER:
        return t('checkout.myCartPaymentMethod.payWithPlan.lineItem');
      case PaymentOptionType.MEMBERSHIP_OFFLINE:
        return t('cart.myCartPaymentMethod.offlinePlan.lineItemWithoutId');
      case PaymentOptionType.FULL_PAYMENT_OFFLINE:
        return pricing.unitPrice.convertedAmount > 0 && t('cart.myCartPaymentMethod.offlinePayment.lineItem');
      /* istanbul ignore next */
      default:
        return '';
    }
  };

  return (
    <div>
      <span data-hook={CartItemDataHook.PaymentTypeLabel} className={s.paymentLabel}>
        {getLabel()}
      </span>
    </div>
  );
};
